import React from 'react'
import userService from '../Service/userService'
import { Modal } from 'react-bootstrap'
import { config } from '../Config/config'

export default class login extends React.Component {
    constructor() {
        super()
        this.state = {
            formdata: {
                id_user: '',
                email: '',
                password: '',
                retype_pass: '',
                otp: ''
            },
            cekEmail: "",
            oldPass: "",
            is_locked: false,
            errors: {},
            showModalOtp: false,
            showModalPass: false,
            token: {},
            time: 0,
            minutes: 0,
            second: 0,
            displayCount: '',
            displaySend: 'none',
            ListOld: [],
            listToken: [],
            disabled: false,
            showModalLoad: false
        }
    }

    cancelHandler = () => {
        this.setState({
            showModalOtp: false,
            errors: {}
        })
    }

    cancelHandlerPass = () => {
        this.setState({
            showModalPass: false,
            errors: {}
        })
    }

    changeHandler = field => ({ target: { value } }) => {
        this.setState({
            formdata: {
                ...this.state.formdata,
                [field]: value
            }
        })
    }

    onSetPassword = async () => {
        if (this.handleValidationPass()) {
            const respon = await userService.resetPassword(this.state.formdata)
            console.log(respon)
            if (respon.success) {
                const responlog = await userService.resetPasswordlog({
                    "id_user": this.state.formdata.id_user,
                    "old_password": this.state.oldPass,
                    "new_password": this.state.formdata.password
                })
                if (responlog.success) {
                    this.setState({
                        showModalPass: false
                    })
                }
            }
        }
    }

    onKonfirmasi = async () => {
        if (this.handleValidationOTP()) {
            if (this.handleValidationOTP()) {
                const respon = await userService.expToken(this.state.token)
                if (respon.success) {
                    this.setState({
                        showModalOtp: false,
                        showModalPass: true
                    })
                    clearInterval(this.interval)
                }
            }
        }
    }

    onLupass = async () => {
        this.setState({
            disabled:true
          })
        const responEmail = await userService.cekEmail(this.state.formdata.email)
        console.log(responEmail)
        if (responEmail.success) {
            this.setState({
                disabled:false
            })
            if (responEmail.result != undefined) {
                this.setState({
                    cekEmail: responEmail.result.email,
                    oldPass: responEmail.result.password,
                    is_locked: responEmail.result.is_locked,
                    formdata: {
                        ...this.state.formdata,
                        ["id_user"]: responEmail.result._id
                    }
                })
            }
        }
        // console.log(this.handleValidation())
        if (this.handleValidation()) {

            var tmpList = []
            const responOld = await userService.getOldpass(this.state.formdata.id_user)
            console.log(responOld)
            if (responOld.success) {
                for (let i = 0; i < responOld.result.length; i++) {
                    tmpList.push(responOld.result[i].old_password)
                }
                this.setState({
                    ListOld: tmpList
                }, () => console.log(this.state.ListOld))
            }
            this.setState({
                showModalLoad: true
            }, () => {
                this.props.cancelforgotHandler()
                this.sendOtp()
            })

            // console.log("muncul oi")
        }
    }

    sendOtp = async () => {
        let tmpList = []
        this.setState({
            disabled: true,
            displayCount: '',
            displaySend: 'none',
            errors: {}
        })
        const responList = await userService.listExpToken(this.state.formdata.email)
        console.log(responList)
        if (responList.success) {
            for (let i = 0; i < responList.result.length; i++) {
                tmpList.push(responList.result[i].token)
            }
            this.setState({
                listToken: tmpList
            }, async () => {
                const responTOK = await userService.expToken(this.state.formdata)
                if (responTOK.success) {
                    const respon = await userService.sendOtp(this.state.formdata)
                    this.setState({
                        disabled: true
                    })
                    if (respon.success) {
                        const responToken = await userService.insertToken({ email: this.state.formdata.email, otp: respon.result, user_id: this.state.formdata.id_user })
                        // console.log(responToken.result.ops[0])
                        if (responToken.success) {
                            this.setState({
                                showModalOtp: true,
                                showModalLoad:false,
                                token: responToken.result.ops[0],
                                time: 30,
                                displayCount: '',
                                displaySend: 'none'
                            })
                            this.props.cancelforgotHandler()
                            this.interval = setInterval(() => this.updateCountdown(), 1000);
                            this.setState({
                                disabled: false
                            })
                        }
                    }
                }
            })
        }
    }

    updateCountdown() {
        const { time } = this.state
        if (time == 0) {
            clearInterval(this.interval)
            this.setState({
                displayCount: 'none',
                displaySend: ''
            })
        }
        let minutes = Math.floor(time / 60)
        let second = time % 60;
        second = second < 10 ? '0' + second : second
        minutes = minutes < 10 ? '0' + minutes : minutes
        this.setState({
            minutes: minutes,
            second: second,
            time: this.state.time - 1
        })
    }

    handleValidation() {
        const { cekEmail, is_locked } = this.state
        let fields = this.state.formdata;
        let errors = {};
        let formIsValid = true;

        //Email
        if (fields["email"] !== cekEmail) {
            formIsValid = false;
            errors["email"] = "The email address you entered isn't connected to an account.";

        }

        if (typeof fields["email"] !== "undefined") {
            let lastAtPos = fields["email"].lastIndexOf('@');
            let lastDotPos = fields["email"].lastIndexOf('.');

            if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fields["email"].indexOf('@@') == -1 && lastDotPos > 2 && (fields["email"].length - lastDotPos) > 2)) {
                formIsValid = false;
                errors["email"] = "Email is not valid";
            }
        }



        if (!fields["email"]) {
            formIsValid = false;
            errors["email"] = "Cannot be empty";
        }

        if (is_locked === true) {
            formIsValid = false;
            // errors["is_locked"] = "your accound is locked by admin, contact adminastator for detail.";
            alert("your accound is locked by admin, contact adminastator for detail.")
            window.location.href = '/'
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    handleValidationOTP = () => {
        let fields = this.state.formdata;
        let fields2 = this.state.token
        let errors = {};
        let formIsValid = true;

        //Name
        if (!fields["otp"]) {
            formIsValid = false;
            errors["otp"] = "Cannot be empty";
        }

        if (fields["otp"] != fields2['token']) {
            formIsValid = false;
            errors["otp"] = "Otp salah";
        }

        if (this.state.listToken.indexOf(parseInt(this.state.formdata.otp)) != -1) {
            formIsValid = false
            errors["otp"] = "OTP kadaluarsa, silakan kirim ulang OTP"
        } else {
            // console.log(this.state.listToken.indexOf(parseInt(this.state.Model.otp)))
        }

        if ((new Date() > new Date(this.state.token.expired_on)) && (fields["otp"] == fields2['token'])) {
            formIsValid = false;
            errors["otp"] = "OTP kadaluarsa, silakan kirim ulang OTP";
            userService.expToken(this.state.token)
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    handleValidationPass = () => {
        let fields = this.state.formdata;
        let errors = {};
        let formIsValid = true;

        //Name
        if (!fields["password"]) {
            formIsValid = false;
            errors["password"] = "Cannot be empty";
        }

        if (typeof fields["password"] !== "undefined") {
            if (!fields["password"].match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)) {
                formIsValid = false;
                errors["password"] = "Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character";
            }
        }

        if (fields["retype_pass"] != fields["password"] && !errors["password"]) {
            formIsValid = false;
            errors["match"] = "Password not match";
        }

        if (fields["retype_pass"] == fields["password"] && !errors["password"]) {
            if (this.state.ListOld.includes(fields["password"])) {
                formIsValid = false
                errors["match"] = "You already use this password before"

            }
        }

        this.setState({ errors: errors });
        return formIsValid;
    }


    cancelforgotHandler = () => {
        this.setState({
            errors: {}
        }, () => { this.props.cancelforgotHandler() })
    }


    render() {
        const { errors, showModalOtp, displayCount, displaySend, showModalPass, formdata, showModalLoad } = this.state
        const { ShowModalforgot, cancelforgotHandler, ModalHandler } = this.props
        return (
            <div>
                <Modal show={ShowModalforgot} onHide={this.cancelforgotHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>Lupa Password</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <div class="main-wrapper account-wrapper">
                            <form action="javascript:void(0)" onSubmit={this.onLupass}>
                                <div class="account-logo">
                                    <a href="/"><img src="assets/img/logo-dark.png" alt="" /></a>
                                </div>
                                <div class="form-group">
                                    <label>Enter Your Email</label>
                                    <input type="text" class="form-control" autofocus onChange={this.changeHandler('email')} />
                                    <span className="error">{errors["email"]}</span>
                                </div>
                                <div class="form-group text-center">
                                    <button class="btn btn-primary account-btn" type="button" onClick={this.onLupass} disabled={this.state.disabled}>Reset Password</button>
                                </div>
                                <div class="text-center register-link">
                                    <a href="javascript:void(0)" onClick={ModalHandler}>Back to Login</a>
                                </div>
                            </form>
                        </div>
                    </Modal.Body>

                </Modal>
                <Modal show={showModalOtp} onHide={this.cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>Email Verifikasi</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div class="main-wrapper  account-wrapper">
                            <form action="javascript:void(0)" onSubmit={this.onKonfirmasi}>
                                <div class="account-logo">
                                    <a href="/"><img src="assets/img/logo-dark.png" alt="" /></a>
                                </div>
                                <div class="form-group">
                                    <label>OTP</label>
                                    <input type="number" placeholder="Masukan OTP" class="form-control noArrow" value={formdata.otp} maxlength="6" onChange={this.changeHandler('otp')} />
                                    <span className="error">{errors["otp"]}</span>
                                </div>

                                {/* <span className="error">{errors["email"]}</span> */}
                                <div class="form-group text-center">
                                    <span style={{ display: `${displayCount}` }}>Kirim ulang kode otp dalam {this.state.minutes}:{this.state.second}</span>
                                    <button class="btn btn-primary account-btn" type="button" style={{ display: `${displaySend}` }} onClick={this.sendOtp}>Send OTP</button>
                                </div>
                                <div class="form-group text-center">
                                    <button class="btn btn-primary account-btn" type="button" onClick={this.onKonfirmasi}>Konfirmasi</button>
                                </div>
                            </form>
                        </div>
                    </Modal.Body>

                </Modal>
                <Modal show={showModalPass} onHide={this.cancelHandlerPass}>
                    <Modal.Header closeButton>
                        <Modal.Title>Set Password</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/* {JSON.stringify(this.state.formdata)} */}
                        {/* {JSON.stringify(this.state.errors)} */}

                        <div class="main-wrapper  account-wrapper">
                            <form action="javascript:void(0)" onSubmit={this.onSetPassword}>
                                <div class="account-logo">
                                    <a href="/"><img src="assets/img/logo-dark.png" alt="" /></a>
                                </div>
                                <div class="form-group">
                                    <label>Password</label>
                                    <input type="password" placeholder="password" class="form-control" onChange={this.changeHandler('password')} />
                                    <span className="error">{errors["password"]}</span>
                                </div>
                                <div class="form-group">
                                    <label>Retype Password</label>
                                    <input type="password" placeholder="retype-password" class="form-control" onChange={this.changeHandler('retype_pass')} />
                                    <span className="error">{errors["match"]}</span>
                                </div>
                                <div class="form-group text-center">
                                    <button class="btn btn-primary account-btn" type="button" onClick={this.onSetPassword}>set password</button>
                                </div>
                            </form>
                        </div>
                    </Modal.Body>
                </Modal>


                <Modal show={showModalLoad}>
                    <Modal.Header>
                        <Modal.Title>Loading...</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div class="main-wrapper account-wrapper">
                            <h1>Sedang mengirim otp</h1>
                            <div class="d-flex justify-content-center">
                                <div class="spinner-border text-primary" role="status" style={{ width: "2em", height: "2em", fontSize: "2em" }}>
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}